<template>
    <div class="Sinistro-Principal">
        <PageTitle icon="fa fa-car" main="Sinistros"
            sub="Sinistro" />
        <div class="Sinistro-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Sinistro" active><SinistroLancamento /></b-tab>                                                                                                                        
                    <b-tab title="Indicadores"><SinistroPainel /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import SinistroLancamento from '../sinistro/SinistroLancamento'
import SinistroPainel from '../sinistro/SinistroPainel'
export default {
    name: 'SinistroPrincipal',    
    components: { PageTitle, SinistroLancamento,SinistroPainel}
    
}
</script>

<style>

</style>






